import queryString from 'query-string';
import type { PlanInterval, PlanTier } from '../../graphql/generated/graphql';

export const TIER_KEY = 'tier';
export const INTERVAL_KEY = 'interval';

const billingQuery = (tier: PlanTier, interval: PlanInterval) =>
  queryString.stringify({
    [TIER_KEY]: tier,
    [INTERVAL_KEY]: interval,
  });

export default billingQuery;
